import request from '@/utils/request'

// 获取小程序配置
export function getMiniProgramConfig() {
  return request({
    url: '/system/mini-program/config',
    method: 'get'
  })
}

// 保存小程序配置
export function saveMiniProgramConfig(data) {
  return request({
    url: '/system/mini-program/config',
    method: 'post',
    data
  })
}